import React from "react";
import { Helmet } from "react-helmet";

const SEOHead = ({
	title,
	description,
	keywords = [],
	canonicalUrl,
	ogImage = "/logo.png",
	ogType = "website",
	structuredData,
}) => {
	const fullTitle = title
		? `${title} | Emmanuel Kyeremeh`
		: "Emmanuel Kyeremeh - Software Engineer & Data Analyst";
	const fullDescription =
		description ||
		"Emmanuel Kyeremeh - Software Engineer and Data Analyst with expertise in React.js, Next.js, Node.js, Express.js, FastAPI, Flask, and MongoDB. Building innovative web applications and machine learning solutions.";
	const fullKeywords = keywords.join(", ");
	const siteUrl = "https://emmanuelkyeremeh.vercel.app";
	const fullCanonicalUrl = canonicalUrl
		? `${siteUrl}${canonicalUrl}`
		: siteUrl;
	const fullOgImage = ogImage.startsWith("http")
		? ogImage
		: `${siteUrl}${ogImage}`;

	return (
		<Helmet>
			{/* Basic Meta Tags */}
			<title>{fullTitle}</title>
			<meta name="description" content={fullDescription} />
			<meta name="keywords" content={fullKeywords} />
			<meta name="author" content="Emmanuel Kyeremeh" />
			<meta name="robots" content="index, follow" />
			<link rel="canonical" href={fullCanonicalUrl} />

			{/* Open Graph Meta Tags */}
			<meta property="og:title" content={fullTitle} />
			<meta property="og:description" content={fullDescription} />
			<meta property="og:image" content={fullOgImage} />
			<meta property="og:url" content={fullCanonicalUrl} />
			<meta property="og:type" content={ogType} />
			<meta
				property="og:site_name"
				content="Emmanuel Kyeremeh Portfolio"
			/>
			<meta property="og:locale" content="en_US" />

			{/* Twitter Card Meta Tags */}
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={fullTitle} />
			<meta name="twitter:description" content={fullDescription} />
			<meta name="twitter:image" content={fullOgImage} />
			<meta name="twitter:creator" content="@aning49" />
			<meta name="twitter:site" content="@aning49" />

			{/* Additional Meta Tags */}
			<meta
				name="viewport"
				content="width=device-width, initial-scale=1.0"
			/>
			<meta name="theme-color" content="#000000" />
			<meta name="msapplication-TileColor" content="#000000" />

			{/* Structured Data */}
			{structuredData && (
				<script type="application/ld+json">
					{JSON.stringify(structuredData)}
				</script>
			)}
		</Helmet>
	);
};

export default SEOHead;
